
import { forkJoin as observableForkJoin, Observable, forkJoin } from 'rxjs';
import { Component, OnInit, ElementRef } from '@angular/core';
import { TextContentService } from "app/text-content/text-content.service";
import { Data, IData } from "./utils"
import { ContentTextResource, NewTopicHtmlFlags } from "app/models/ContentTextResource";
import { NotificationsService } from "angular2-notifications";
import { ContentTextResource2 } from "app/models/ContentTextResource2";
import { FormBuilder, Validators, FormControl } from "@angular/forms";
import { ContentCommonResource } from "app/models/ContentCommonResource";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ContentCommonFileListResource } from "app/models/ContentCommonFileListResource";
import { ContentCommonFileResource } from "app/models/ContentCommonFileResource";
import { Router } from "@angular/router";
import { TagResource } from "app/models/TagResource";
import { UtilsService } from "app/services/utils.service";
import { TermsOrGdprResource } from 'app/models/TermsOrGdprResource';
import { TinyMceComponent } from 'app/tinymce-editor/tinymce-editor.component';

@Component({
	selector: 'vbn-text-content',
	templateUrl: './text-content.component.html',
	styleUrls: ['./text-content.component.scss'],
	providers: [TextContentService]
})
export class TextContentComponent implements OnInit {

	userEmail: string;
	text: TermsOrGdprResource
	gdpr: TermsOrGdprResource
	errorMessage: any;
	terms: boolean = true
	saveErrors: boolean = false;
	selected_language: string;
	showDelete: boolean = false;

	constructor(
		private translate: TranslateService,
		private _textContentService: TextContentService,
		private _notificationService: NotificationsService,
		private fb: FormBuilder,
		private router: Router,
		private element: ElementRef,
		private utilsService: UtilsService, ) {
		}

	ngOnInit() {
		this.userEmail = this.utilsService.currentUserEmail;
	}







	changeText(value) {
	//	if (value) {
					this.router.navigate(['/edit-content-text/' + btoa('{ "terms" : "' + value + '"}')]);

	/* 	} else {
			this.terms = false
		}
		this.getByUser(this.userEmail, value) */
	}

	







}
